/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-unused-expressions */
import { ChangeDetectorRef, OnChanges, SimpleChanges, HostListener } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { UbicacionesService } from 'app/home/search-box/service/ubicaciones.service';
import { UserService } from 'app/pages/com.usblick.common/auth/user.service';
import { ItineraryService } from 'app/shared/itinerary.service';
import { ConfirmationModalComponent } from 'app/shared/modals/confirmation-modal/confirmation-modal.component';
import * as moment from 'moment';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { Observable, Subscription, Subject, pipe } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, takeUntil } from 'rxjs/operators';
import { NotificationService } from 'app/shared/notifications/notification.service';

@Component({
  selector: 'usb-form-flight-internal',
  templateUrl: './form-flight-internal.component.html',
  styleUrls: ['./form-flight-internal.component.scss']
})
export class FormFlightInternalComponent implements OnInit, OnDestroy , OnChanges {

  @Input() flightsInternal: any[];
  @Input() firstFly: any;
  @Input() formTransports: any;
  @Input() getClientsSettingAppBooking: any;
  @Input() component = '';
  @Input() itineraryId: number;
  @Input() closeOtherAccordions: number | null = null;
  @Output() deleteFly = new EventEmitter();
  @Output() formValidityChange = new EventEmitter<boolean>();
  @Output() submitFly = new EventEmitter();
  @Output() accordionStateChange = new EventEmitter<boolean>();

  flightsInternalForm: FormArray;

    // flightIn: flightIn;
    // flightOut: flightOut;
    dpConfig: Partial<BsDatepickerConfig> = new BsDatepickerConfig();
    modalRef: BsModalRef;
    minDate: Date;
    _formFlights: FormGroup;
    config = {
      animated: true,
      keyboard: true,
      backdrop: true,
      ignoreBackdropClick: true
    };
    ismeridian = true;
    selectedAirportIn: string[] = [];
    selectedAirportInId: any[] = [];
    selectedAirportInCountryCode: any[] = [];
    selectedAirlineIn: any[] = [];
    selectedAirportOut: string[] = [];
    selectedAirlineOut: string[] = [];
    onlyIn = false;
    onlyOut = false;

    flightId: any;

    // valueAirlineIn: any;
    valueAirlineCodeIata: any[] = [];


    minDateDepartureOneInternal: Date;
    minHourArrivalOneInternal: string;


    minDateArrivalOneInternal: Date[] = [];
    maxDateDepartureOneInternal: Date[] = [];



    maxDateArrivalOneInternal: Date;


    minDateDeparturateOut: Date;
    minDateArrivalOut: Date;
    maxDateDepartureDateIn: Date = null;
    bsConfig: object;
    message = [];

    isLoadingResult: boolean;
    errorMsg: string;
    keyword = 'nameAirline';

    _flightNumberIn: any;
    __airlineIn: any;
    minArrivalInHour: string | null = null;
    isHoveredCancelDate: boolean;
    flyShowComponent: any;
    flyArr: any[] = [];
    tooltipFlight = false;
    colorFlight: string;

  selectedCityIataIn: any[] = [];
  valueCityCodeIataIn: any[] = [];
  selectedCityIataInName: any[] = [];

  selectedIataCityArrivalOutName: any[] = [];
  selectedIataCityArrivalOut: any[] = [];
  valueCityCodeIataOut: any[] = [];
  selectedAirlineInName: any[] = [];
  selectedAirportNameOut: any[] = [];
  selectedAirlineOutName: any[] = [];
  isAccordionOpen: boolean[] = [];
  anyAccordionOpen = false;

  // Wheel time picker support - keyed by flight index and field name
  activeTimePicker: { index: number; field: string } | null = null;
  currentTime: string = new Date().toLocaleTimeString([], {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
  });


  countriesList: any[] = [];
  // Mantén una copia interna del array anterior para comparar
  private previousFlightsInternal: any[] = [];
  private destroy$ = new Subject<void>();
  private formSubscription: Subscription;

  constructor(private formBuilder: FormBuilder,
              private ubicacionesService: UbicacionesService,
              private _sanitizer: DomSanitizer,
              private notificationService: NotificationService,
              private userService: UserService,
              private _itineraryService: ItineraryService,
              private modalService: BsModalService,
              private cdr: ChangeDetectorRef
  ) {
    this.dpConfig.dateInputFormat = 'DD/MM/YYYY';
    // Keep the picker consistent with our UTC-parsed FormControls so the day
    // does not shift in non-UTC browser timezones.
    // ngx-bootstrap 7.x reads `useUtc` from the config object at runtime, but
    // the typings for BsDatepickerConfig do not declare it, so we cast through any.
    (this.dpConfig as any).useUtc = true;
  }

  ngOnInit(): void {
    this.initFlightsInternalForm();
    this.subscribeToFormChanges();

      // Inicializar con el valor actual
    this.previousFlightsInternal = [...this.flightsInternal];
  }

ngOnChanges(changes: SimpleChanges): void {

    if (changes['flightsInternal'] && this.flightsInternal) {

      this.handleFlightsInternalChange();
    }
  }

    onAccordionToggle(index: number, isOpen: boolean) {
    this.isAccordionOpen[index] = isOpen;

    // Cerrar otros acordeones si este se abre
    if (isOpen) {
      this.closeOtherAccordionsExcept(index);
      // Emitir al padre que un acordeón se abrió
      this.accordionStateChange.emit(true);
      this.anyAccordionOpen = true;
    } else {
      // Verificar si todos están cerrados
      this.anyAccordionOpen = this.isAccordionOpen.some(state => state === true);
      if (!this.anyAccordionOpen) {
        this.accordionStateChange.emit(false);
      }
    }
  }

  private closeOtherAccordionsExcept(openIndex: number) {
    this.isAccordionOpen.forEach((state, index) => {
      if (index !== openIndex && state) {
        this.isAccordionOpen[index] = false;
      }
    });
  }

  /**
   * Maneja los cambios en el array de vuelos
   */
  private handleFlightsInternalChange(): void {
    // Verificar si realmente hubo un cambio en la longitud del array
    if(this.previousFlightsInternal.length > 0) {
      if (this.flightsInternal.length !== this.previousFlightsInternal.length) {
        this.updateFormArray();
      } else {
        // Si la longitud es la misma, verificar si hay elementos nuevos sin ID
        const hasNewUnsavedFlights = this.flightsInternal.some((flight, index) => {
          const isNewUnsaved = flight.id === null &&
            (this.previousFlightsInternal[index] === undefined ||
             this.previousFlightsInternal[index]?.id !== null);

          return isNewUnsaved;
        });

        if (hasNewUnsavedFlights) {
          this.updateFormArray();
        } else {
        }
      }
    }

    // Actualizar la copia anterior
    this.previousFlightsInternal = [...this.flightsInternal];

  }

  /**
   * Actualiza el FormArray cuando cambia el array de vuelos
   */
  updateFormArray(): void {

    // Limpiar el formArray actual
    this.clearFormArray(this.flightsInternalForm);

    // Recrear el formArray con los nuevos vuelos
    this.flightsInternal?.forEach((flight, index) => {
      // if(flight?.id === null) {
        this.flightsInternalForm.push(this.createProductForm(flight));
      // }
    });

    this.patchAllFlightsWithId();

        if(this.flightsInternal.length > 1) {

          this.flightsInternalForm.controls.forEach((formGroup: FormGroup, index: number) => {

            if(index === 0) {
               if (this.firstFly?.arrivalIn) {

                const arrivalInDate = new Date(this.firstFly.arrivalIn);
                this.minDateArrivalOneInternal[0] = new Date(
                                                          arrivalInDate.getFullYear(),
                                                          arrivalInDate.getMonth(),
                                                          arrivalInDate.getDate()
                                                          );


              }
            } else {

                    const previousFlight = this.flightsInternal[index - 1];

                    if (previousFlight.arrivalIn) {
                      const previousArrivalDate = new Date(previousFlight.arrivalIn);
                      this.minDateArrivalOneInternal[index] = new Date(
                        previousArrivalDate.getFullYear(),
                        previousArrivalDate.getMonth(),
                        previousArrivalDate.getDate()
                      );
                    }

                    if (previousFlight.departureOut) {
                      const previousArrivalDate = new Date(previousFlight.departureOut);
                      this.maxDateDepartureOneInternal[index] = new Date(
                        previousArrivalDate.getFullYear(),
                        previousArrivalDate.getMonth(),
                        previousArrivalDate.getDate()
                      );
                    }
            }

            if(index === this.flightsInternal.length - 1) {
                  if (this.firstFly?.departureOut) {
                    // Extraer la fecha (YYYY-MM-DD)
                  const departureOutDate = new Date(this.firstFly.departureOut);


                    this.maxDateDepartureOneInternal[index] = new Date(
                                                              departureOutDate.getFullYear(),
                                                              departureOutDate.getMonth(),
                                                              departureOutDate.getDate()
                                                              );

                  }
            }
          });
    }
  }

  private clearFormArray(formArray: FormArray): void {
    while (formArray?.length > 0) {
      formArray.removeAt(0);
    }
  }

  ngOnDestroy(): void {
    if (this.formSubscription) {
      this.formSubscription.unsubscribe();
    }
    this.destroy$.next();
    this.destroy$.complete();
  }




    subscribeToFormChanges(): void {
    // Suscribirse a cambios de valor
    this.formSubscription = this.flightsInternalForm.valueChanges.subscribe(() => {
      this.emitFormValidity();
    });

    // También suscribirse a cambios de estado (touched, dirty, etc)
    this.formSubscription.add(
      this.flightsInternalForm.statusChanges.subscribe(() => {
        this.emitFormValidity();
      })
    );

    // Emitir estado inicial
    this.emitFormValidity();
  }

  /**
   * Computes effective validity, ignoring the `bsDate` widget error that
   * ngx-bootstrap's datepicker leaves on date controls when their value is
   * set via `patchValue` from a JS `Date` (instead of the user's typing).
   * The Date is functionally valid — only the widget's parser noise is wrong.
   */
  private _isEffectivelyValid(): boolean {
    return this.flightsInternalForm.controls.every((fg: AbstractControl) => {
      if (!(fg instanceof FormGroup)) {
return true;
}
      for (const ctrl of Object.values((fg as FormGroup).controls)) {
        if (!ctrl.errors) {
continue;
}
        const realErrors = Object.keys(ctrl.errors).filter(k => k !== 'bsDate');
        if (realErrors.length > 0) {
return false;
}
      }
      return true;
    });
  }

  emitFormValidity(): void {
    const isValid = this._isEffectivelyValid();
    this.formValidityChange.emit(isValid);
  }

  getHeading(index: any): string {

    return `${this.selectedAirportNameOut[index] ? this.selectedAirportNameOut[index] : 'Salida'} ----> ${this.selectedCityIataInName[index] ? this.selectedCityIataInName[index] : 'Llegada'}`;

  }

  initFlightsInternalForm(): void {
      this.flightsInternalForm = this.formBuilder.array(
            this.flightsInternal.map(product => this.createProductForm(product))
        );

        this.patchAllFlightsWithId();

        // Deshabilitar campos específicos después de inicializar el formulario
        this.disableSpecificFields();
        this.subscribeFormCheckDatesOut();


        if(this.flightsInternal.length > 1) {



        } else {

          if (this.firstFly?.arrivalIn) {

            const arrivalInDate = new Date(this.firstFly.arrivalIn);
            this.minDateArrivalOneInternal[0] = new Date(
                                                      arrivalInDate.getFullYear(),
                                                      arrivalInDate.getMonth(),
                                                      arrivalInDate.getDate()
                                                      );


          }

            if (this.firstFly?.departureOut) {
            // Extraer la fecha (YYYY-MM-DD)
           const departureOutDate = new Date(this.firstFly.departureOut);


            this.maxDateDepartureOneInternal[0] = new Date(
                                                      departureOutDate.getFullYear(),
                                                      departureOutDate.getMonth(),
                                                      departureOutDate.getDate()
                                                      );

          }


        }

  }

   /**
    * Deshabilita los campos específicos del formulario
    */
  private disableSpecificFields(): void {
    // Deshabilitar campos específicos en cada formulario del FormArray
    this.flightsInternalForm.controls.forEach((formGroup: FormGroup) => {
      formGroup.get('arrivalHourIn')?.disable();
      formGroup.get('departureHourIn')?.disable();
      formGroup.get('arrivalHourOut')?.disable();
      formGroup.get('departureHourOut')?.disable();
      formGroup.get('arrivalDateIn')?.disable();
      formGroup.get('departureDateIn')?.disable();
      formGroup.get('arrivalDateOut')?.disable();
    });
  }

   subscribeFormCheckDatesIn(): void {
  this.flightsInternalForm.controls.forEach((formGroup: FormGroup, index: number) => {
      const checkEnableArrivalInFields = () => {

        // arrivalDateOut
        const departureDate = formGroup.get('departureDateIn')?.value;
        const departureHour = formGroup.get('departureHourIn')?.value;
        const arrivalDateIn = formGroup.get('arrivalDateIn')?.value;
        const arrivalHourIn = formGroup.get('arrivalHourIn')?.value;
        // 1. departureHourIn depende de departureDateIn


        if (departureDate) {
          formGroup.get('departureHourIn')?.enable({ emitEvent: false });
          // formGroup.get('departureHourOut')?.enable({ emitEvent: false });
        } else {
          formGroup.get('departureHourIn')?.disable({ emitEvent: false });
          // formGroup.get('departureHourIn')?.reset(null, { emitEvent: false });
        }

        // 2. arrivalDateIn depende de departureHourIn
        if (departureDate && departureHour) {
          formGroup.get('arrivalDateIn')?.enable({ emitEvent: false });
        } else {
          formGroup.get('arrivalDateIn')?.disable({ emitEvent: false });
          // formGroup.get('arrivalDateIn')?.reset(null, { emitEvent: false });
        }

        // 3. arrivalHourIn depende de arrivalDateIn
        if (arrivalDateIn) {
          // Si necesitas mantener minDateArrivalOut por formulario, deberías usar un array
          // this.minDateArrivalOut[index] = new Date(arrivalDateIn);
          formGroup.get('arrivalHourIn')?.enable({ emitEvent: false });
          // formGroup.get('departureDateOut')?.enable({ emitEvent: false });
        } else {
          formGroup.get('arrivalHourIn')?.disable({ emitEvent: false });
          // formGroup.get('arrivalHourIn')?.reset(null, { emitEvent: false });
          formGroup.get('departureDateOut')?.disable({ emitEvent: false });
          // formGroup.get('departureDateOut')?.reset(null, { emitEvent: false });
        }
      };

      // Configuración reusable del debounce
      const debounceConfig = (time: number = 750) =>
        pipe(debounceTime(time), distinctUntilChanged());

      // Suscripciones con debounce para cada formulario
      formGroup.get('departureDateIn')?.valueChanges
        .pipe(
          debounceConfig(),
          takeUntil(this.destroy$) // Importante para desuscribirse automáticamente
        )
        .subscribe(() => checkEnableArrivalInFields());

      formGroup.get('departureHourIn')?.valueChanges
        .pipe(
          debounceConfig(),
          takeUntil(this.destroy$)
        )
        .subscribe(() => checkEnableArrivalInFields());

      formGroup.get('arrivalDateIn')?.valueChanges
        .pipe(
          debounceConfig(),
          takeUntil(this.destroy$)
        )
        .subscribe(() => {
          checkEnableArrivalInFields();
          this.updateMinArrivalInHour(formGroup, index); // Pasar el formGroup específico
        });

      formGroup.get('arrivalHourIn')?.valueChanges
        .pipe(
          debounceConfig(),
          takeUntil(this.destroy$)
        )
        .subscribe(() => {
          checkEnableArrivalInFields();
          this.validateArrivalHourIn(formGroup); // Pasar el formGroup específico
        });

    });
  }



    /**
     * Calcula y establece la hora mínima permitida para la llegada de vuelos de entrada
     *
     * Este método determina la hora mínima de llegada basado en la fecha y hora de salida,
     * aplicando la restricción de que la llegada debe ser al menos 1 minuto después de la salida
     * cuando las fechas de salida y llegada son iguales.
     *
     * @logic
     * - Si salida y llegada son el mismo día: hora llegada ≥ hora salida + 1 minuto
     * - Si son días diferentes: no aplica restricción horaria
     *
     * @conditions
     * - departureDateIn debe tener valor
     * - departureHourIn debe tener valor
     * - arrivalDateIn debe tener valor
     * - Fechas de salida y llegada deben ser iguales (mismo día)
     *
     * @operations
     * - Calcula hora mínima sumando 1 minuto a la hora de salida
     * - Formatea y setea el valor mínimo en arrivalHourIn
     * - Resetea el campo si no aplican las condiciones
     *
     * @uses formatTime() - Método para formatear objeto Date a string HH:mm
     */
    // Calcula el mínimo permitido
    updateMinArrivalInHour(formGroup: any, index: number): void {
      const departureDate = formGroup.get('departureDateIn')?.value;
      const departureHour = formGroup.get('departureHourIn')?.value;
      const arrivalDate = formGroup.get('arrivalDateIn')?.value;

      if (departureDate && departureHour && arrivalDate &&
          departureDate.getFullYear() === arrivalDate.getFullYear() &&
          departureDate.getMonth() === arrivalDate.getMonth() &&
          departureDate.getDate() === arrivalDate.getDate()) {
        const [hours, minutes] = departureHour.split(':').map(Number);
        const minDate = new Date();
        minDate.setHours(hours);
        minDate.setMinutes(minutes + 1);
       formGroup.get('arrivalHourIn')?.setValue(this.formatTime(minDate), { emitEvent: false });
      } else {
        const flight = this.flightsInternal[index];
        if(flight && flight.arrivalIn) {
        } else {
          formGroup.get('arrivalHourIn')?.reset({ emitEvent: false });
        }
      }
    }

     /**
      * Valida que la hora de llegada sea coherente con la hora de salida
      *
      * Este método compara las horas de salida y llegada cuando ocurren en el mismo día
      * y asegura que la hora de llegada no sea anterior a la hora de salida, mostrando
      * una advertencia al usuario y corrigiendo automáticamente el valor si es necesario.
      *
      * @validation
      * - Solo aplica cuando departureDateIn y arrivalDateIn son el mismo día
      * - arrivalHourIn debe ser posterior a departureHourIn
      * - Si arrivalHourIn es anterior, se corrige a departureHourIn + 1 minuto
      *
      * @actions
      * 1. Compara fechas usando moment.js para formato consistente
      * 2. Si arrivalHourIn es anterior, calcula hora corregida
      * 3. Setea el valor corregido en el formulario
      * 4. Muestra toast de advertencia al usuario
      *
      * @uses moment.js - Para parsing y comparación de fechas/horas
      * @uses notificationService.warning() - Para notificar al usuario sobre la corrección
      *
      * @example
      * // Si departureHourIn = "14:30" y arrivalHourIn = "14:25"
      * // Se corrige a "14:31" y muestra advertencia
      */
    validateArrivalHourIn(formGroup): void {
      const departureDate = formGroup.get('departureDateIn')?.value;
      const arrivalDate = formGroup.get('arrivalDateIn')?.value;
      const departureHour = formGroup.get('departureHourIn')?.value;
      const arrivalHour = formGroup.get('arrivalHourIn')?.value;

      if (departureDate && arrivalDate && departureHour && arrivalHour) {
        const depDate = moment(departureDate).format('YYYY-MM-DD');
        const arrDate = moment(arrivalDate).format('YYYY-MM-DD');

        // Solo comparar si las fechas son iguales
        if (depDate === arrDate) {
          const depTime = moment(`${depDate} ${departureHour}`, 'YYYY-MM-DD HH:mm');
          const arrTime = moment(`${arrDate} ${arrivalHour}`, 'YYYY-MM-DD HH:mm');

          if (arrTime.isBefore(depTime)) {
            const correctedTime = depTime.clone().add(1, 'minutes');
            const formatted = correctedTime.format('HH:mm');
            formGroup.get('arrivalHourIn')?.setValue(formatted, { emitEvent: false });

            this.notificationService.warning('El horario de llegada no puede ser menor al de salida.');
          }
        }
      }
    }


      /**
       * Suscribe y gestiona las validaciones y habilitación condicional de campos de fecha/hora para vuelos de salida
       *
       * Este método configura un sistema de dependencias entre campos para vuelos de salida (out)
       * donde la habilitación de cada campo depende de que el campo anterior tenga un valor válido.
       * Aplica debounce para optimizar el rendimiento y prevenir procesamiento excesivo.
       *
       * @dependencies
       * - departureHourOut → depende de → departureDateOut
       * - arrivalDateOut → depende de → departureDateOut + departureHourOut
       * - arrivalHourOut → depende de → arrivalDateOut
       *
       * @actions
       * 1. Habilita/deshabilita campos basado en dependencias en cadena
       * 2. Resetea campos dependientes cuando se deshabilitan
       * 3. Aplica validaciones de coherencia temporal
       * 4. Optimiza con debounce para mejor rendimiento
       *
       * @uses debounceTime(750) - Evita múltiples ejecuciones en escritura rápida
       * @uses distinctUntilChanged() - Previene procesamiento con valores duplicados
       *
       * @sideEffects
       * - Ejecuta updateMinArrivalOutHour() para calcular mínimos
       * - Ejecuta validateArrivalHourOut() para validaciones
       */
      subscribeFormCheckDatesOut(): void {
              this.flightsInternalForm.controls.forEach((formGroup: FormGroup, index: number) => {
        const checkEnableArrivalOutFields = () => {

          const departureDate = formGroup.get('departureDateOut')?.value;
          const departureHour = formGroup.get('departureHourOut')?.value;
          const arrivalDateOut = formGroup.get('arrivalDateOut')?.value;
          const arrivalHourOut = formGroup.get('arrivalHourOut')?.value;

          // 1. departureHourIn depende de departureDateIn
          if (departureDate) {
            formGroup.get('departureHourOut')?.enable({ emitEvent: false });

          } else {
            formGroup.get('departureHourOut')?.disable({ emitEvent: false });
            // formGroup.get('departureHourOut')?.reset(null, { emitEvent: false });; // Opcional: para limpiar el campo
          }

          // 2. arrivalDateIn depende de departureHourIn
          if (departureDate && departureHour) {
            formGroup.get('arrivalDateOut')?.enable({ emitEvent: false });

          } else {
            formGroup.get('arrivalDateOut')?.disable({ emitEvent: false });
            // formGroup.get('arrivalDateOut')?.reset(null, { emitEvent: false });; // Opcional
          }

          // 3. arrivalHourIn depende de arrivalDateIn
          if (arrivalDateOut) {
            formGroup.get('arrivalHourOut')?.enable({ emitEvent: false });
          } else {
            formGroup.get('arrivalHourOut')?.disable({ emitEvent: false });
            // formGroup.get('arrivalHourOut')?.reset(null, { emitEvent: false });; // Opcional
          }

        };

          const debounceConfig = (time: number = 750) =>
        pipe(debounceTime(time), distinctUntilChanged());


              // Suscripciones con debounce
        formGroup.get('departureDateOut')?.valueChanges
          .pipe(debounceConfig(), takeUntil(this.destroy$))
          .subscribe(() => checkEnableArrivalOutFields());

        formGroup.get('departureHourOut')?.valueChanges
          .pipe(debounceConfig(), takeUntil(this.destroy$))
          .subscribe(() => {
            checkEnableArrivalOutFields();
            this.validateDepartureHourOut(formGroup, index);
          });

        formGroup.get('arrivalDateOut')?.valueChanges
          .pipe(debounceConfig(), takeUntil(this.destroy$))
          .subscribe(() => {
            checkEnableArrivalOutFields();
            // this.updateMinArrivalOutHour(formGroup, index);
          });

        formGroup.get('arrivalHourOut')?.valueChanges
          .pipe(debounceConfig(), takeUntil(this.destroy$))
          .subscribe(() => {
            checkEnableArrivalOutFields();
            this.validateArrivalHourOut(formGroup, index);
          });
          });

      }



    /**
     * Calcula y establece la hora mínima permitida para la llegada de vuelos de salida
     *
     * Este método determina la hora mínima de llegada para vuelos de salida basado en
     * la fecha y hora de salida, aplicando la restricción de que la llegada debe ser
     * al menos 1 minuto después de la salida cuando ocurren el mismo día.
     *
     * @logic
     * - Mismo día: hora llegada ≥ hora salida + 1 minuto
     * - Días diferentes: sin restricción horaria específica
     *
     * @conditions
     * - departureDateOut debe tener valor
     * - departureHourOut debe tener valor
     * - arrivalDateOut debe tener valor
     * - Fechas de salida y llegada deben ser iguales (mismo día)
     *
     * @operations
     * - Parsea hora de salida y suma 1 minuto
     * - Formatea y setea el valor mínimo en arrivalHourOut
     * - Resetea el campo si no aplican las condiciones
     *
     * @uses formatTime() - Para convertir Date a string HH:mm
     */
        updateMinArrivalOutHour(formGroup, index): void {
          const departureDate = formGroup.get('departureDateOut')?.value;
          const departureHour = formGroup.get('departureHourOut')?.value;
          const arrivalDate = formGroup.get('arrivalDateOut')?.value;

          if (departureDate && departureHour && arrivalDate &&
              departureDate.getFullYear() === arrivalDate.getFullYear() &&
              departureDate.getMonth() === arrivalDate.getMonth() &&
              departureDate.getDate() === arrivalDate.getDate()) {
            const [hours, minutes] = departureHour.split(':').map(Number);
            const minDate = new Date();
            minDate.setHours(hours);
            minDate.setMinutes(minutes + 1);
            formGroup.get('arrivalHourOut')?.setValue(this.formatTime(minDate), { emitEvent: false });
          } else {
            this.minArrivalInHour = null;
            formGroup.get('arrivalHourOut')?.reset({ emitEvent: false });
          }
        }

validateDepartureHourOut(formGroup: FormGroup, index: number): void {
  const departureDate = formGroup.get('departureDateOut')?.value;
  const arrivalDate = formGroup.get('arrivalDateOut')?.value;
  const departureHour = formGroup.get('departureHourOut')?.value;
  const arrivalHour = formGroup.get('arrivalHourOut')?.value;

  if (departureDate && arrivalDate && departureHour && arrivalHour) {
    const depDate = moment(departureDate).format('YYYY-MM-DD');
    const arrDate = moment(arrivalDate).format('YYYY-MM-DD');

    // Solo comparar si las fechas son iguales
    if (depDate === arrDate) {
      const depTime = moment(`${depDate} ${departureHour}`, 'YYYY-MM-DD HH:mm');
      const arrTime = moment(`${arrDate} ${arrivalHour}`, 'YYYY-MM-DD HH:mm');

      if (arrTime.isBefore(depTime)) {
        const correctedTime = depTime.clone().add(1, 'minutes');
        const formatted = correctedTime.format('HH:mm');
        formGroup.get('arrivalHourOut')?.setValue(formatted, { emitEvent: false });
        this.notificationService.warning('El horario de llegada no puede ser menor al de salida.');
      }
    }
  }

  // Validación adicional: no puede ser menor al vuelo anterior
  this.validateAgainstPreviousFlight(formGroup, index);
}

validateArrivalHourOut(formGroup: FormGroup, index: number): void {
  const departureDate = formGroup.get('departureDateOut')?.value;
  const arrivalDate = formGroup.get('arrivalDateOut')?.value;
  const departureHour = formGroup.get('departureHourOut')?.value;
  const arrivalHour = formGroup.get('arrivalHourOut')?.value;

  if (departureDate && arrivalDate && departureHour && arrivalHour) {
    const depDate = moment(departureDate).format('YYYY-MM-DD');
    const arrDate = moment(arrivalDate).format('YYYY-MM-DD');

    if (depDate === arrDate) {
      const depTime = moment(`${depDate} ${departureHour}`, 'YYYY-MM-DD HH:mm');
      const arrTime = moment(`${arrDate} ${arrivalHour}`, 'YYYY-MM-DD HH:mm');

      if (arrTime.isBefore(depTime)) {
        const correctedTime = depTime.clone().add(1, 'minutes');
        const formatted = correctedTime.format('HH:mm');
        formGroup.get('arrivalHourOut')?.setValue(formatted, { emitEvent: false });
        this.notificationService.warning('El horario de llegada no puede ser menor al de salida.');
      }
    }
  }

  // Validación adicional: no puede superar al vuelo siguiente
  this.validateAgainstNextFlight(formGroup, index);
}

/**
 * Valida que el vuelo interno no se superponga con el vuelo anterior
 */
private validateAgainstPreviousFlight(formGroup: FormGroup, index: number): void {
  if (index === 0) {
return;
} // Primer vuelo no tiene anterior

  const previousFlight = this.flightsInternal[index - 1];
  if (!previousFlight?.arrivalOut) {
return;
}

  const currentDepartureDate = formGroup.get('departureDateOut')?.value;
  const currentDepartureHour = formGroup.get('departureHourOut')?.value;

  if (currentDepartureDate && currentDepartureHour) {
    const previousArrival = moment(previousFlight.arrivalOut);
    const currentDeparture = moment(`${moment(currentDepartureDate).format('YYYY-MM-DD')} ${currentDepartureHour}`, 'YYYY-MM-DD HH:mm');

    if (currentDeparture.isBefore(previousArrival)) {
      const correctedTime = previousArrival.clone().add(1, 'minutes');
      const formattedDate = correctedTime.format('YYYY-MM-DD');
      const formattedHour = correctedTime.format('HH:mm');

      formGroup.get('departureDateOut')?.setValue(new Date(formattedDate), { emitEvent: false });
      formGroup.get('departureHourOut')?.setValue(formattedHour, { emitEvent: false });

      this.notificationService.warning('El horario de salida no puede ser menor al horario de llegada del vuelo anterior.');
    }
  }
}

/**
 * Valida que el vuelo interno no se superponga con el vuelo siguiente
 */
private validateAgainstNextFlight(formGroup: FormGroup, index: number): void {
  if (index === this.flightsInternal.length - 1) {
return;
} // Último vuelo no tiene siguiente

  const nextFlight = this.flightsInternal[index + 1];
  if (!nextFlight?.departureOut) {
return;
}

  const currentArrivalDate = formGroup.get('arrivalDateOut')?.value;
  const currentArrivalHour = formGroup.get('arrivalHourOut')?.value;

  if (currentArrivalDate && currentArrivalHour) {
    const currentArrival = moment(`${moment(currentArrivalDate).format('YYYY-MM-DD')} ${currentArrivalHour}`, 'YYYY-MM-DD HH:mm');
    const nextDeparture = moment(nextFlight.departureOut);

    if (currentArrival.isAfter(nextDeparture)) {
      const correctedTime = nextDeparture.clone().subtract(1, 'minutes');
      const formattedDate = correctedTime.format('YYYY-MM-DD');
      const formattedHour = correctedTime.format('HH:mm');

      formGroup.get('arrivalDateOut')?.setValue(new Date(formattedDate), { emitEvent: false });
      formGroup.get('arrivalHourOut')?.setValue(formattedHour, { emitEvent: false });

      this.notificationService.warning('El horario de llegada no puede ser mayor al horario de salida del vuelo siguiente.');
    }
  }
}

    /**
     * Formatea un objeto Date a string en formato HH:mm con 2 dígitos
     *
     * Este método utility convierte la parte horaria de un objeto Date
     * a un string formateado con horas y minutos de 2 dígitos cada uno.
     *
     * @param date - Objeto Date a formatear
     * @returns - Hora formateada como "HH:mm" (ej: "09:05", "14:30")
     *
     * @format
     * - Horas: 2 dígitos con leading zero (00-23)
     * - Minutos: 2 dígitos con leading zero (00-59)
     *
     * @uses
     * - getHours(): Obtiene horas del Date (0-23)
     * - getMinutes(): Obtiene minutos del Date (0-59)
     * - padStart(2, '0'): Asegura 2 dígitos con leading zeros
     *
     * @example
     * // Retorna: "09:05"
     * this.formatTime(new Date(2023, 11, 25, 9, 5));
     *
     * @example
     * // Retorna: "14:30"
     * this.formatTime(new Date(2023, 11, 25, 14, 30));
     */
  formatTime(date: Date): string {
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${hours}:${minutes}`;
  }



      createProductForm(product: any): FormGroup {
        return this.formBuilder.group({

                          // van a ser el in
                          airlineOut: new FormControl(null, Validators.required),
                          _flightNumberOut: new FormControl(null, Validators.required),
                          flightNumberOut: new FormControl(null,[Validators.required, Validators.minLength(3)]),
                          cityDepartureIn: new FormControl(null, Validators.required),
                          departureDateOut: new FormControl(null, Validators.required),
                          departureHourOut: new FormControl(null, Validators.required),
                          arrivalDateOut: new FormControl(null, Validators.required),
                          arrivalHourOut: new FormControl(null, Validators.required),
                          airportOut: new FormControl(null, Validators.required),
                          // 'DEPARTURE' = Salida, 'ARRIVAL' = Llegada.
                          // Default on creation is DEPARTURE (Salida) per product spec.
                          flightDirection: new FormControl(product?.flight_direction || 'DEPARTURE'),
                          isConfigured: [false]
        });




    }

    patchAllFlightsWithId(): void {
  if (!this.flightsInternal || !this.flightsInternalForm) {
    return;
  }

  this.flightsInternal.forEach((flight: any, index: number) => {
    // Solo hacer patch si el flight tiene ID
    if (flight.id) {
      this.patchForm(flight, index);
    } else {
    }
  });
}

    patchForm(flight: any, index: number): void {

        // Obtener el FormGroup específico del FormArray
        const formGroup = this.flightsInternalForm.at(index) as FormGroup;

        if (!formGroup) {
          return;
        }

        this.maxDateDepartureDateIn = null;

        if(flight.iataCityArrivalOut) {
          formGroup.get('cityDepartureIn')?.setValue(flight.iataCityArrivalOut);
          this.selectedCityIataIn[index] =flight.iataCityArrivalOut;
          this.valueCityCodeIataIn[index] = flight.iataCityArrivalOut;
          const iataCityDepartureIn = this.ubicacionesService.getCitys(flight.iataCityArrivalOut).pipe(
                  map((response: any) =>
                    // Retorna solo el array hotels de la respuesta
                     response.find(r  => r.type === 'city')?.cities || [] // Usa array vacío si hotels no existe
                  )
                );
          iataCityDepartureIn.subscribe({
                  next: (res: any) => {
                    if(res.length > 0) {
                      const iataCity = res.find(c => c.city_iata_code === flight?.iataCityArrivalOut && `${c.city_name}, ${c.country_name}` === flight?.cityArrivalOut);
                      this.selectedCityIataInName[index] = `${iataCity.city_name}, ${iataCity.country_name}`;
                    }
                  }
                });
        }


        this.selectedAirportIn[index] = flight?.airportIataCodeIn;
        this.selectedAirportInCountryCode[index] = flight?.iata_code;
        this.selectedAirportInId[index] = flight?.id_airport;
        // Continuar con todos los patches para este formGroup específico

        formGroup.get('airportIn')?.setValue({name: flight.airportIn, iata: flight?.airportIataCodeIn});
        formGroup.get('airportOut')?.setValue({name: flight?.airportOut, iata: flight?.airportIataCodeOut});
        formGroup.get('airlineIn')?.setValue({name: flight?.airlineIn, iata: flight?.airlineIataCodeIn});
        formGroup.get('airlineOut')?.setValue({name: flight?.airlineOut, iata: flight?.airlineIataCodeOut});

        this.selectedAirlineInName[index] = flight?.airlineIn;
        this.selectedAirlineOutName[index] = flight?.airlineOut;
        this.selectedAirportNameOut[index] = flight?.airportOut;
        this.selectedAirportOut[index] = flight?.airportIataCodeOut;

        const departureIn = this.parseLocalDateTime(flight?.departureIn);
        const arrivalIn = this.parseLocalDateTime(flight?.arrivalIn);
        const departureOut = this.parseLocalDateTime(flight?.departureOut);
        const arrivalOut = this.parseLocalDateTime(flight?.arrivalOut);

        if (flight?.arrivalIn) {
          formGroup.patchValue({
            flightNumberIn: flight.flyNumberIn ? flight.flyNumberIn : null,
            departureDateIn: departureIn ? departureIn : null,
            departureHourIn: departureIn ? this._extractHourMinute(departureIn.toString()) : null,
          });

          setTimeout(() => {
            formGroup.patchValue({
              arrivalDateIn: arrivalIn ? arrivalIn : null,
              arrivalHourIn: arrivalIn ? this._extractHourMinute(arrivalIn.toString()) : null,
            });
          }, 0);
        }

        if (flight?.arrivalOut) {
          formGroup.patchValue({
            _flightNumberOut: flight?.airlineIataCodeOut ? flight?.airlineIataCodeOut: null,
            flightNumberOut: flight.flyNumberOut ? flight.flyNumberOut : null,
            departureDateOut: departureOut ? departureOut : null,
            departureHourOut: departureOut ? this._extractHourMinute(departureOut.toString()) : null,
          });

          setTimeout(() => {
            formGroup.patchValue({
              arrivalDateOut: arrivalOut ? arrivalOut : null,
              arrivalHourOut: arrivalOut ? this._extractHourMinute(arrivalOut.toString()) : null,
            });
          }, 0);
        }

        // Marcar como configurado
        formGroup.get('isConfigured')?.setValue(true);

        this.cdr.detectChanges();
      }

    getFormForFly(index: any): FormGroup {
      // const index = this.flightsInternal.findIndex(p => p.id === fly.id);
      return this.flightsInternalForm.at(index) as FormGroup;
    }

    getAutoCompleteSource(type: 'airport' | 'airline'): (keyword: string) => Observable<any[]> {
      return (keyword: string) => this.ubicacionesService.getAirportsAirlines(keyword, type);
    }

      getAutoCompleteSourceDestination(keyoword?: string): (keyword: string) => Observable<any[]> {
        return (keyword: string) => this.ubicacionesService.getCitys(keyword).pipe(
            map((response: any) =>
              // Retorna solo el array hotels de la respuesta
               response.find(r  => r.type === 'city')?.cities || [] // Usa array vacío si hotels no existe
            )
          );
      }

      _myListFormatterAirport = (data: any) => {
    // fa fa-building-o
    const html = `<span class='fa fa-plane'style='color:#a9a4a4'>
                      </span>
                      <span style='font-size:15px;cursor:pointer;line-height:2.1;'>
                        ${ this.capitalize(data['name'])}
                      </span>
                      <span style=' font-weight: 500;font-size:14px;color:black'>
                       (${data['iata']})
                      </span>`;

     return this._sanitizer.bypassSecurityTrustHtml(html);
  };

    capitalize(val: any) {
    return val.toLowerCase()
            .trim()
            .split(' ')
            .map( v => v[0].toUpperCase() + v.substr(1) )
            .join(' ');
  }


  deleteFlyInternal(index: any): void {
    const existsFly = this.flightsInternal[index];

    if(existsFly && existsFly?.id) {
      this.deleteFly.emit({flyExists: true, id: existsFly.id});
    } else {
      this.deleteFly.emit({flyExists: false, id: index});
    }

    this.updateFormArray();
    this.emitFormValidity();
  }


  /***********************************************Auto Complete********************************************/


/**
 * Formatea la visualización de aerolíneas en listas desplegables
 *
 * Este método genera HTML seguro para mostrar información de aerolíneas en formatos
 * personalizados dentro de componentes de autocompletado o selección.
 *
 * @param data - Objeto con los datos de la aerolínea
 * @param data.name - Nombre de la aerolínea
 * @param data.iata - Código IATA de la aerolínea
 *
 * @returns - HTML sanitizado y seguro para renderizar
 *
 * @uses DomSanitizer.bypassSecurityTrustHtml - Para permitir HTML seguro
 *
 * @format
 * - Ícono de avión (fa-plane)
 * - Nombre de la aerolínea
 * - Código IATA entre paréntesis en negrita
 *
 * @example
 * // Retorna: HTML con "Cubana de Aviación (CU)"
 * this._myListFormatterAirline({name: 'Cubana de Aviación', iata: 'CU'});
 */
  _myListFormatterAirline = (data: any) => {

      const html = `<span class='fa fa-plane'style='color:#a9a4a4'>
      </span>
      <span style='font-size:15px;cursor:pointer;line-height:2.1;'>
        ${ data['name']}
      </span>
      <span style=' font-weight: 500;font-size:14px;color:black'>
       (${data['iata']})
      </span>`;

    return this._sanitizer.bypassSecurityTrustHtml(html);

  };


  /**
   * Callback para manejar la selección de aeropuerto de entrada
   *
   * Este método se ejecuta cuando se selecciona un aeropuerto en componentes de entrada
   * y actualiza las propiedades relacionadas con el aeropuerto de llegada.
   *
   * @param data - Objeto con datos del aeropuerto seleccionado
   * @param data.id - ID del aeropuerto
   * @param data.country_code - Código de país del aeropuerto
   * @param data.iata - Código IATA del aeropuerto
   * @param data.nameAirport - Nombre del aeropuerto
   * @param data.codeIataAirport - Código IATA del aeropuerto (alternativo)
   *
   * @returns - Cadena formateada para display: "Nombre (IATA) (IATA)"
   *
   * @sideEffects
   * - Actualiza selectedAirportInId con el ID del aeropuerto
   * - Actualiza selectedAirportInCountryCode con el código de país
   * - Actualiza selectedAirportIn con el código IATA
   *
   * @condition
   * - Si hay payloadSearch y es categoría 8 con pickupLocation tipo 'airport',
   *   aplica lógica específica de transfers
   *
   * @example
   * // Retorna: "José Martí (HAV) (HAV)"
   * this._myCallbackAirportIn({
   *   id: 123,
   *   country_code: 'CU',
   *   iata: 'HAV',
   *   nameAirport: 'José Martí',
   *   codeIataAirport: 'HAV'
   * });
   */
  _myCallbackAirportOut(data: any, index: number): string {
    if (data) {
      this.selectedAirportNameOut[index] = `${data['name']} (${data['iata']})`;
      this.selectedAirportInId[index] = data['id'];
      this.selectedAirportOut[index] = data['iata'];
      this.selectedAirportInCountryCode[index] = data['country_code'];
      this.selectedAirportOut[index] = data['iata'];
     return `${data['nameAirport']} (${data['codeIataAirport']}) (${data['codeIataAirport']})`;
    }
  }

//   /**
//  * Callback para manejar la selección de aeropuerto de salida
//  *
//  * Este método se ejecuta cuando se selecciona un aeropuerto en componentes de salida
//  * y actualiza las propiedades relacionadas con el aeropuerto de partida.
//  *
//  * @param {any} data - Objeto con datos del aeropuerto seleccionado
//  * @param {string} data.name - Nombre del aeropuerto
//  * @param {string} data.iata - Código IATA del aeropuerto
//  * @param {string} data.country_code - Código de país del aeropuerto
//  *
//  * @returns {string} - Cadena formateada para display: "Nombre (IATA)"
//  *
//  * @sideEffects
//  * - Actualiza selectedAirportOut con el código IATA
//  * - En condiciones específicas de transfers, actualiza propiedades de aeropuerto de entrada
//  *
//  * @condition
//  * - Si hay payloadSearch, es categoría 8, pickupLocation no es 'airport'
//  *   y dropoffLocation es 'airport', actualiza propiedades de aeropuerto de entrada
//  *
//  * @example
//  * // Retorna: "Juan Gualberto Gómez (VRA)"
//  * this._myCallbackAirportOut({
//  *   name: 'Juan Gualberto Gómez',
//  *   iata: 'VRA',
//  *   country_code: 'CU'
//  * });
//  */
//   _myCallbackAirportOut(data: any): string {
//    if (data) {
//     if(this.payloadSearch && this.payloadSearch[0].categoriesId[0] === 8 &&
//       this.payloadSearch[0].transfers.pickupLocation.type !== 'airport' &&
//       this.payloadSearch[0].transfers.dropoffLocation.type === 'airport') {
//           this.selectedAirportInCountryCode = data['country_code'];
//           this.selectedAirportIn = data['iata']; // codeIataCity
//     }
//     console.log(this.selectedAirportOut)
//     this.selectedAirportOut =  data['iata']; //his._airportOut['codeIataAirport'];
//     return `${data['name']} (${data['iata']})`;
//    }
//   }

  /**
   * Callback para manejar la selección de aerolínea de entrada
   *
   * Este método se ejecuta cuando se selecciona una aerolínea en componentes de entrada
   * y actualiza las propiedades relacionadas con la aerolínea de llegada.
   *
   * @param data - Objeto con datos de la aerolínea seleccionada
   * @param data.name - Nombre de la aerolínea
   * @param data.iata - Código IATA de la aerolínea
   *
   * @returns - Cadena formateada para display: "Nombre (IATA)"
   *
   * @sideEffects
   * - Actualiza selectedAirlineIn con el código IATA de la aerolínea
   * - Actualiza valueAirlineCodeIata con el código IATA seleccionado
   * - Parchea el formulario _formFlights con _flightNumberIn
   *
   * @example
   * // Retorna: "Cubana de Aviación (CU)"
   * this._myCallbackAirlineIn({
   *   name: 'Cubana de Aviación',
   *   iata: 'CU'
   * });
   */
  _myCallbackAirlineIn(data: any, fly: any, index: number): string {
    if (data) {
       const flyForm = this.getFormForFly(index);
      this.selectedAirlineIn[index] = data['iata'];
      this.selectedAirlineInName[index] = data['name'];
      this.valueAirlineCodeIata[index] = this.selectedAirlineIn;
      flyForm.patchValue({
        _flightNumberIn:  this.selectedAirlineIn[index],
      });
      return `${data['name']} (${data['iata']})`;
    }
  }

  /**
   * Callback para manejar la selección de aerolínea de salida
   *
   * Este método se ejecuta cuando se selecciona una aerolínea en componentes de salida
   * y actualiza las propiedades relacionadas con la aerolínea de partida.
   *
   * @param data - Objeto con datos de la aerolínea seleccionada
   * @param data.name - Nombre de la aerolínea
   * @param data.iata - Código IATA de la aerolínea
   *
   * @returns - Cadena formateada para display: "Nombre (IATA)"
   *
   * @sideEffects
   * - Actualiza selectedAirlineOut con el código IATA de la aerolínea
   * - Parchea el formulario _formFlights con _flightNumberOut
   *
   * @example
   * // Retorna: "American Airlines (AA)"
   * this._myCallbackAirlineOut({
   *   name: 'American Airlines',
   *   iata: 'AA'
   * });
   */
  _myCallbackAirlineOut(data: any, fly: any, index): string {
   if (data) {

    const flyForm = this.getFormForFly(index);
     this.selectedAirlineOut[index] = data['iata'];
     this.selectedAirlineOutName[index] = data['name'];
     flyForm.patchValue({
       _flightNumberOut:  this.selectedAirlineOut[index],
     });
    return `${data['name']} (${data['iata']})`;
   }
  }

  /**
   * Callback para manejar la selección de ciudad IATA de entrada
   *
   * Este método se ejecuta cuando se selecciona una ciudad en componentes de entrada
   * y actualiza las propiedades relacionadas con la ciudad de origen del vuelo.
   *
   * @param data - Objeto con datos de la ciudad seleccionada
   * @param data.city_name - Nombre de la ciudad
   * @param data.country_name - Nombre del país
   * @param data.city_iata_code - Código IATA de la ciudad
   *
   * @returns - Cadena formateada para display: "Ciudad, País"
   *
   * @sideEffects
   * - Actualiza selectedCityIataInName con "Ciudad, País"
   * - Actualiza selectedCityIataIn con el código IATA de la ciudad
   * - Actualiza valueCityCodeIataIn con el código IATA seleccionado
   * - Parchea el formulario _formFlights con cityDepartureIn
   *
   * @example
   * // Retorna: "La Habana, Cuba"
   * this._myCallbackCityIataIn({
   *   city_name: 'La Habana',
   *   country_name: 'Cuba',
   *   city_iata_code: 'HAV'
   * });
   */
    _myCallbackCityIataIn(data: any, fly: any, index): string {

    if (data) {
       const flyForm = this.getFormForFly(index);
      this.selectedCityIataInName[index] = `${data['city_name']}, ${data['country_name']}`;
      this.selectedCityIataIn[index] = data['city_iata_code'];
      this.valueCityCodeIataIn[index] = this.selectedCityIataIn[index];
      flyForm.patchValue({
        iataCityArrivalOut: this.selectedCityIataIn[index],
        cityDepartureIn:  this.selectedCityIataIn[index],
      });
      return `${data['city_name']}, ${data['country_name']}`;
    }
  }

  /**
   * Callback para manejar la selección de ciudad IATA de salida
   *
   * Este método se ejecuta cuando se selecciona una ciudad en componentes de salida
   * y actualiza las propiedades relacionadas con la ciudad de destino del vuelo.
   *
   * @param data - Objeto con datos de la ciudad seleccionada
   * @param data.city_name - Nombre de la ciudad
   * @param data.country_name - Nombre del país
   * @param data.city_iata_code - Código IATA de la ciudad
   *
   * @returns - Cadena formateada para display: "Ciudad, País"
   *
   * @sideEffects
   * - Actualiza selectedIataCityArrivalOutName con "Ciudad, País"
   * - Actualiza selectedIataCityArrivalOut con el código IATA de la ciudad
   * - Actualiza valueCityCodeIataOut con el código IATA seleccionado
   * - Parchea el formulario _formFlights con iataCityArrivalOut
   *
   * @example
   * // Retorna: "Miami, Estados Unidos"
   * this._myCallbackCityIataOut({
   *   city_name: 'Miami',
   *   country_name: 'Estados Unidos',
   *   city_iata_code: 'MIA'
   * });
   */
  _myCallbackCityIataOut(data: any, fly: any, index: number): string {
    if (data) {
       const flyForm = this.getFormForFly(index);
      this.selectedIataCityArrivalOutName[index] = `${data['city_name']}, ${data['country_name']}`;
      this.selectedIataCityArrivalOut[index] = data['city_iata_code'];
      this.valueCityCodeIataOut[index] = this.selectedIataCityArrivalOut[index];
       flyForm.patchValue({
        iataCityArrivalOut:  this.selectedIataCityArrivalOut[index],
      });
      return `${data['city_name']}, ${data['country_name']}`;
    }
  }

//   /**
//  * Factory function que retorna una función de autocompletado para aeropuertos o aerolíneas
//  *
//  * Este método genera funciones de búsqueda para componentes de autocompletado que
//  * se conectan con el servicio de ubicaciones para obtener datos en tiempo real.
//  *
//  * @param {'airport' | 'airline'} type - Tipo de búsqueda: 'airport' o 'airline'
//  * @returns {(keyword: string) => Observable<any[]>} - Función que recibe keyword y retorna Observable con resultados
//  *
//  * @uses ubicacionesService.getAirportsAirlines - Servicio para obtener datos de aeropuertos/aerolíneas
//  *
//  * @example
//  * // Uso en componente de autocompletado:
//  * const airportSource = this.getAutoCompleteSource('airport');
//  * airportSource('hav').subscribe(results => {...});
//  *
//  * @example
//  * // Uso con aerolíneas:
//  * const airlineSource = this.getAutoCompleteSource('airline');
//  * airlineSource('cub').subscribe(results => {...});
//  */
//   getAutoCompleteSource(type: 'airport' | 'airline'): (keyword: string) => Observable<any[]> {
//     return (keyword: string) => {
//       return this.ubicacionesService.getAirportsAirlines(keyword, type);
//     };
//   }

  /**
   * Función observable para fuentes de datos de autocompletado de aeropuertos/aerolíneas
   *
   * Este método proporciona una fuente de datos observable para componentes de búsqueda
   * que necesitan obtener sugerencias de aeropuertos o aerolíneas basadas en keywords.
   *
   * @param keyword - Término de búsqueda ingresado por el usuario
   * @param type - Tipo de búsqueda: 'airport' o 'airline'
   * @returns - Observable con array de resultados o error message
   *
   * @uses ubicacionesService.getAirportsAirlines - Servicio principal de búsqueda
   *
   * @errorHandling
   * - Si el servicio retorna undefined, captura el mensaje de error en errorMsg
   * - Retorna el observable del servicio o maneja el error apropiadamente
   *
   * @example
   * // Uso en componente:
   * this.observableSourceAirportAirline('miami', 'airport').subscribe(
   *   results => console.log(results),
   *   error => console.error(error)
   * );
   */
  observableSourceAirportAirline = (keyword: string, type: string): Observable<any[]> => {
    const results = this.ubicacionesService.getAirportsAirlines(keyword, type);
    if (results !== undefined) {
      return results;
    } else {
      this.errorMsg = results['message'];
    }
  };

/**
 * Formatea la visualización de destinos (ciudades) en listas desplegables
 *
 * Este método genera HTML seguro para mostrar información de ciudades en formatos
 * personalizados dentro de componentes de autocompletado o selección.
 *
 * @param data - Objeto con los datos de la ciudad
 * @param data.city_name - Nombre de la ciudad
 * @param data.country_name - Nombre del país
 *
 * @returns - HTML sanitizado y seguro para renderizar
 *
 * @uses DomSanitizer.bypassSecurityTrustHtml - Para permitir HTML seguro
 *
 * @format
 * - Ícono de marcador de mapa (fa-map-marker)
 * - Nombre de la ciudad seguido de coma
 * - Nombre del país en negrita
 *
 * @example
 * // Retorna: HTML con "La Habana, Cuba"
 * this._myListFormatterDestination({
 *   city_name: 'La Habana',
 *   country_name: 'Cuba'
 * });
 */
    _myListFormatterDestination = (data: any) => {

      const html = `<span class='fa fa-map-marker'style='color:#a9a4a4'>
      </span>
      <span style='font-size:15px;cursor:pointer;line-height:2.1;'>
        ${ data['city_name']},
      </span>
      <span style=' font-weight: 500;font-size:14px;color:black'>
        ${data['country_name']}
      </span>`;

    return this._sanitizer.bypassSecurityTrustHtml(html);

  };


  /**
   * Elimina la opción seleccionada de un campo específico y limpia propiedades relacionadas
   *
   * Este método proporciona una forma centralizada de resetear campos del formulario
   * y sus propiedades asociadas según el tipo de campo especificado.
   *
   * @param type - Tipo de campo a limpiar
   * @returns
   *
   * @supportedTypes
   * - 'airportIn': Aeropuerto de entrada
   * - 'airlineIn': Aerolínea de entrada
   * - 'airportOut': Aeropuerto de salida
   * - 'airlineOut': Aerolínea de salida
   * - 'cityDepartureIn': Ciudad de salida
   * - 'iataCityArrivalOut': Ciudad de llegada IATA
   *
   * @actions
   * - Resetea el valor del control del formulario
   * - Limpia propiedades del componente relacionadas
   * - Maneja casos especiales para transfers con categoría 8
   *
   * @specialCase
   * Para 'airportOut' con transfers específicos, también limpia propiedades de aeropuerto de entrada
   */
  deleteSelectedOption(type: string, index: number): void {

    const form = this.flightsInternalForm.at(index) as FormGroup;

    switch(type) {
      case 'airportIn':
        form.get('airportIn')?.setValue('');
        // this.selectedAirportIn = '';
        this.selectedAirportInId[index] = undefined;
        this.selectedAirportInCountryCode[index] = undefined;

        break;
      case 'airlineIn':
        form.get('airlineIn')?.setValue(null);
        form.get('_flightNumberIn')?.setValue(null);
        this.selectedAirlineIn[index] = undefined;
        this.valueAirlineCodeIata[index] = undefined;
        break;
      case 'airportOut':
        form.get('airportOut')?.setValue(null);
        this.selectedAirportInId[index] = undefined;
        this.selectedAirportInCountryCode[index] = undefined;
        this.selectedAirportNameOut[index] = undefined;
        this.selectedAirportOut[index] = undefined;
        break;
      case 'airlineOut':
          form.get('airlineOut')?.setValue(null);
          form.get('_flightNumberOut')?.setValue(null);
          this.selectedAirlineOut[index] = undefined;
          this.selectedAirlineOutName[index] = undefined;
        break;
      case 'cityDepartureIn':
        form.get('cityDepartureIn')?.setValue(null);
        this.selectedCityIataIn[index] = undefined;
        this.valueCityCodeIataIn[index] = undefined;
        this.selectedCityIataInName[index] = undefined;
        break;
      case 'iataCityArrivalOut':
         form.get('iataCityArrivalOut')?.setValue(null);
           this.selectedIataCityArrivalOutName[index] = undefined;
         this.selectedIataCityArrivalOut[index] = undefined;
         this.valueCityCodeIataOut[index] = undefined;
      default:
        break;
    }
  }



    /**
     * Aplica cambios de vuelos al itinerario actual
     *
     * Este método valida el formulario, construye el payload y realiza peticiones POST o PUT
     * según corresponda para crear o actualizar vuelos en el itinerario actual.
     *
     * @returns {void}
     *
     * @emits updateFly - Evento emitido cuando la operación es exitosa
     *
     * @requires _formFlights válido - El formulario debe pasar las validaciones
     * @requires checkFlight() verdadero - Verificación adicional de vuelos
     *
     * @uses payloadMap() - Método para construir el payload de la petición
     * @uses MaterialModalConfirmComponent - Componente modal para confirmación de acciones
     * @uses _itineraryService._restService - Servicio para peticiones HTTP
     *
     * @example
     * // Ejemplo de uso:
     * this._flightsApply();
     *
     * @response {any} - Respuesta exitosa del servidor
     * @error {HttpErrorResponse} - Error en la petición HTTP
     * @throws {Error} - Error al procesar la operación
     */

  /**
   * Toggle handler for the Salida/Llegada switch.
   * Writes 'DEPARTURE' or 'ARRIVAL' to the per-flight `flightDirection` control
   * without emitting valueChanges (the slider already owns the visual state).
   */
  onFlightDirectionToggle(index: number, event: Event): void {
    const input = event.target as HTMLInputElement;
    const value = input.checked ? 'ARRIVAL' : 'DEPARTURE';
    const formGroup = this.flightsInternalForm.at(index) as FormGroup;
    formGroup.get('flightDirection')?.setValue(value, { emitEvent: false });
  }

    _flightsApply(index: number) {

      const formGroup = this.flightsInternalForm.at(index) as FormGroup;

     if (!formGroup.valid) {
      console.log('Formulario de vuelo inválido:', formGroup, formGroup.value);
      formGroup.markAllAsTouched();
      return;
      }

        const payloadFly = this.payloadMap(index);

        // if(this.checkFlight()) {

          if(this.flightsInternal && this.flightsInternal.length > 0) {
            payloadFly['id'] = this.flightsInternal[index]?.id;
          }
           let textAlert = '';
          if(payloadFly?.id) {
              textAlert = 'Editar vuelo para este file';
          } else{
              textAlert = 'Crear vuelo para este file';
          }

          const initialState: ModalOptions = {
            initialState: {
              title: payloadFly?.id ? 'Editar vuelo' : 'Crear vuelo',
              subtitle: 'para este file',
              message: 'confirme si desea realizar <br /> esta operación',
              icon: '/assets/icons/search-result/airplane_3313713.svg'
            }
          };

          const modalOptions = Object.assign({}, initialState, this.config);
          const modalConfirm = this.modalService.show(ConfirmationModalComponent,  modalOptions);
          const instance = modalConfirm.content as ConfirmationModalComponent;

          if (payloadFly['id']) {
            instance.confirmResult.subscribe((result: boolean) =>{
              if(result) {
                this._itineraryService._restService.doPut('app', `fly_itineraries/${payloadFly['id']}`, payloadFly).subscribe({
                  next: (res: any) => {
                                        this.notificationService.success(`Vuelo actualizado con exito para el file ${this.itineraryId}`);
                                        // this.openModalFly = false;
                                        // this.updateFly.emit(true);
                                        // this.closeModal();
                                        this.submitFly.emit();
                                      },
                  error: (error: HttpErrorResponse) => {
this.notificationService.error(`Hubo un error al actualizar el vuelo para el file ${this.itineraryId}, ${error.error}`);
}
                });
              } else {
                return;
              }
            });

          } else {

            instance.confirmResult.subscribe((result: boolean) => {
              if(result) {
                this._itineraryService._restService.doPost('app', 'fly_itineraries', payloadFly).subscribe({
                  next: (res: any) => {
                                        this.notificationService.success(`Vuelo creado con exito para el file ${this.itineraryId}`);
                                        // this.openModalFly = false;
                                        //   this.updateFly.emit(true);
                                        //   this.closeModal();
                                        this.submitFly.emit();
                                      },
                  error: (error: HttpErrorResponse) => {
this.notificationService.error(`Hubo un error al crear el vuelo para el file ${this.itineraryId}, ${error.error}`), console.log(error);
}
                });
              } else {
                return;
              }
            });
          }
        // }



      }

        /**
         * Construye el payload para operaciones CRUD de vuelos
         *
         * Este método mapea los valores del formulario de vuelos a un objeto estructurado
         * apto para ser enviado al backend en operaciones POST/PUT.
         *
         * @returns - Objeto payload estructurado para la API
         *
         * @requires _formFlights - Formulario de vuelos debe estar disponible y con controles definidos
         * @requires userService._agentID - ID del agente debe estar disponible
         * @requires selectedAirportInCountryCode - Código IATA del país del aeropuerto de entrada
         * @requires selectedAirportInId - ID del aeropuerto de entrada
         *
         * @structure
         * - Propiedades base: agent_id, iata_code, id_airport, itinerary
         * - Objeto `in`: Datos del vuelo de entrada (si existe)
         * - Objeto `out`: Datos del vuelo de salida (si existe)
         *
         * @uses formatDateOnly() - Método auxiliar para formatear fechas
         * @uses getVal() - Función helper para obtener valores del formulario
         *
         * @example
         * // Ejemplo de uso:
         * const payload = this.payloadMap();
         * this.service.saveFlight(payload).subscribe(...);
         *
         * @note Los valores nulos se manejan con operador de coalescencia nula (??)
         * @note Las fechas se combinan con sus respectivas horas
         */
payloadMap(index): any {
  // Obtener el FormGroup correcto del FormArray
  const formGroup = this.flightsInternalForm.at(index) as FormGroup;

  // Función para obtener valores de manera segura
  const getVal = (controlName: string) => {
    const control = formGroup.get(controlName);
    return control ? control.value : null;
  };

    const departureDateIn = this.formatDateOnly(getVal('departureDateIn'));
    const arrivalDateIn = this.formatDateOnly(getVal('arrivalDateIn'));
    const departureDateOut = this.formatDateOnly(getVal('departureDateOut'));
    const arrivalDateOut = this.formatDateOnly(getVal('arrivalDateOut'));

    let itineraryId = -1;

    if(this.flyShowComponent && this.flyShowComponent?.id) {
      itineraryId = this.flyShowComponent.id;
    }

    // if(itineraryId === -1) {
    //    itineraryId = this._actualItinerary['id']
    // }


        const payload: any = {
          agent_id: this.userService._agentID,
          iata_code: this.selectedAirportInCountryCode[index],
          id_airport: this.selectedAirportInId[index],
          itinerary: this.itineraryId,
          flight_direction: getVal('flightDirection'),

        };

    if(getVal('airlineIn')?.name) {
      payload.in = {
        airline: getVal('airlineIn')?.name ?? null,
        airlineIataCode: getVal('airlineIn')?.iata ?? null,
        airport: getVal('airportIn')?.name ?? null,
        airportIataCode: this.selectedAirportIn[index],
        iataCityDeparture: getVal('cityDepartureIn'),
        flyNumber: getVal('flightNumberIn') ?? null,
        departure: `${departureDateIn} ${getVal('departureHourIn')}`,
        arrival: `${arrivalDateIn} ${getVal('arrivalHourIn')}`,
      };
    }

    if(getVal('airlineOut')?.name) {
      payload.out = {
          airline: getVal('airlineOut')?.name ?? null,
          airlineIataCode: getVal('airlineOut')?.iata ?? null,
          iataCityArrival: getVal('cityDepartureIn'),
          cityArrival: this.selectedCityIataInName[index],
          airport: getVal('airportOut')?.name ?? null,
          airportIataCode: this.selectedAirportOut[index],
          flyNumber: getVal('flightNumberOut') ?? null,
          departure: `${departureDateOut} ${getVal('departureHourOut')}`,
          arrival: `${arrivalDateOut} ${getVal('arrivalHourOut')}`,
      };
    }

    return payload;
  }

  /**
   * Formatea un objeto Date a string en formato ISO (YYYY-MM-DD) sin información de tiempo
   *
   * Este método utility toma un objeto Date y extrae solo la parte de la fecha (año, mes, día),
   * ignorando cualquier información de hora, minutos, segundos y zona horaria.
   *
   * @param date - Objeto Date a formatear
   * @returns - String con la fecha en formato ISO (YYYY-MM-DD) o undefined si la fecha es falsy
   *
   * @example
   * // Ejemplo de uso:
   * const date = new Date('2023-12-25T15:30:00');
   * const formatted = this.formatDateOnly(date); // Retorna "2023-12-25"
   *
   * @note Retorna undefined si el parámetro date es null, undefined o falsy
   * @note Usa el constructor de Date con componentes específicos para evitar problemas de zona horaria
   * @note El método toISOString() siempre retorna la fecha en UTC
   *
   * @implementation
   * 1. Crea un nuevo Date object usando solo año, mes y día
   * 2. Convierte a formato ISO string
   * 3. Extrae los primeros 10 caracteres (YYYY-MM-DD)
   */
  private formatDateOnly(date: Date): string {
    if(!date) {
      return;
    }
  const d = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  return d.toISOString().slice(0, 10);
}


      /**
       * Valida la coherencia temporal entre traslados y vuelos del itinerario
       *
       * Este método realiza validaciones complejas de fechas y horarios para asegurar que:
       * - Los traslados de ida y regreso sean cronológicamente consistentes
       * - Los traslados respeten los tiempos mínimos requeridos respecto a los vuelos
       * - Las fechas de recogida sean anteriores a las de llegada de vuelos
       *
       * @returns - `true` si todas las validaciones pasan, `false` si hay inconsistencias
       *
       * @requires formTransports - Formulario de traslados debe estar disponible
       * @requires _actualItinerary.flights - Información de vuelos debe estar cargada
       *
       * @validation
       * - Fecha de recogida ida vs fecha de regreso
       * - Hora de recogida ida vs hora de regreso (mismo día)
       * - Fecha recogida ida vs fecha llegada vuelo
       * - Hora recogida ida vs hora llegada vuelo (+1h15min margen)
       * - Fecha recogida regreso vs fecha salida vuelo
       * - Hora recogida regreso vs hora salida vuelo (+3h30min margen)
       *
       * @uses moment.js - Para formateo y manipulación de fechas
       * @uses notificationService - Para mostrar mensajes informativos al usuario
       *
       * @example
       * // Ejemplo de uso:
       * const isValid = this.checkFlight();
       * if (!isValid) {
       *   // Mostrar error al usuario
       * }
       *
       * @message {string} - Mensajes descriptivos de error para cada validación fallida
       */
    checkFlight(): boolean {
        let result = true;
        const a = this.formTransports;

            // Declaración de variables para las fechas y horarios de los traslados
          let firstArrivalDate: string;
          let secondArrivalDate: string | null = null; // Inicializa en `null` si es un viaje de ida
          let firstTime: string;
          let secondTime: string;
          let arrivalHourIn: string;
          let arrivalDateIn: string;
          let departureDateOut: string;
          let departureHourOut: string;
          let st = 0; // Inicializa `st` en 0 para evitar errores si no se asigna
          let ft: number;
          let message = '';

          if(a) {
            // Obtiene la fecha y hora del primer traslado
            firstArrivalDate = moment(a['firstArrivalDate'].toString().split(',')[0]).format('YYYY-MM-DD');
            firstTime = moment(a['firstTime'].toString().split(',')[0]).format('HH:mm');

            // Convierte la hora a minutos totales en el día (Ej: 14:30 → 870 minutos)
            ft = parseInt(firstTime.split(':')[0], 10) * 60 + parseInt(firstTime.split(':')[1], 10);

            // Si el tipo de viaje no es "oneTrip" (solo ida), obtiene los datos del segundo traslado
            if (a['type'] !== 'oneTrip') {
                secondArrivalDate = moment(a['secondArrivalDate'].toString().split(',')[0]).format('YYYY-MM-DD');
                secondTime = moment(a['secondTime'].toString().split(',')[0]).format('HH:mm');
                st = parseInt(secondTime.split(':')[0], 10) * 60 + parseInt(secondTime.split(':')[1], 10);
            }

            // Validaciones de los traslados
            if (firstArrivalDate > (secondArrivalDate || firstArrivalDate)) {
                result = false;
                message = `Error, ingrese una fecha de recogida de ida anterior a la de regreso: ${firstArrivalDate}`;
            }

            if ((ft > st) && (firstArrivalDate === secondArrivalDate)) {
                result = false;
                message = `Error, ingrese una hora de recogida de ida anterior a la de regreso: ${secondTime}`;
            }
          }

          // Validaciones en relación con los vuelos
          if ((this.firstFly && this.firstFly?.id)) {

              const fly =  this.firstFly;
              // Obtiene los datos del vuelo
              arrivalDateIn = moment(fly.arrivalIn.toString().split(',')[0]).format('YYYY-MM-DD');
              arrivalHourIn = moment(fly.arrivalIn.toString().split(',')[0]).format('HH:mm');
              const at = parseInt(arrivalHourIn.split(':')[0], 10) * 60 + parseInt(arrivalHourIn.split(':')[1], 10);

              departureDateOut = moment(fly.departureOut.toString().split(',')[0]).format('YYYY-MM-DD');
              departureHourOut = moment(fly.departureOut.toString().split(',')[0]).format('HH:mm');
              const _at = parseInt(departureHourOut.split(':')[0], 10) * 60 + parseInt(departureHourOut.split(':')[1], 10);

              // Verifica si el primer traslado es antes de la llegada del vuelo
              if (firstArrivalDate > arrivalDateIn) {
                  result = false;
                  message = `Error, la fecha de recogida de ida debe ser anterior a la llegada del vuelo: ${arrivalDateIn}`;
              }

              // Ajuste de tiempo mínimo de espera (1 hora y 15 minutos) entre el traslado y el vuelo
              ft = ft + 75;
              if ((ft > at) && (firstArrivalDate === arrivalDateIn)) {
                  result = false;
                  message = `Error, la hora de recogida de ida debe ser al menos 1h 15min antes de la llegada del vuelo: ${arrivalHourIn}`;
              }

              // Verifica si el segundo traslado es después de la salida del vuelo
              if (secondArrivalDate && secondArrivalDate > departureDateOut) {
                  result = false;
                  message = `Error, la fecha de recogida de regreso debe ser anterior a la salida del vuelo: ${departureDateOut}`;
              }

              // Ajuste de tiempo mínimo de espera (3 horas y 30 minutos) entre el traslado y la salida del vuelo
              st = st + 210;
              if ((st > _at) && (secondArrivalDate === departureDateOut)) {
                  result = false;
                  message = `Error, la hora de recogida de regreso debe ser al menos 3h 30min antes de la salida del vuelo: ${departureHourOut}`;
              }
          }

          if(message !== '') {
            this.notificationService.info(message);
          }


        return result;
    }

      /**
       * Parsea un string de fecha-hora en formato ISO a objeto Date local
       *
       * Este método utility convierte strings en formato ISO 8601 (YYYY-MM-DDTHH:mm:ssZ)
       * a objetos Date, manejando correctamente la zona horaria local.
       *
       * @param dateTimeStr - String de fecha-hora en formato ISO
       * @returns - Objeto Date correspondiente o undefined si el string es inválido
       *
       * @parsing
       * 1. Divide en parte de fecha y parte de tiempo
       * 2. Remueve 'Z' (UTC) y milisegundos si están presentes
       * 3. Convierte cada componente a números
       * 4. Crea nuevo Date con componentes específicos
       *
       * @example
       * // Retorna: Date object para 2023-12-25 15:30:00 en zona local
       * this.parseLocalDateTime('2023-12-25T15:30:00Z');
       *
       * @note
       * - Meses se ajustan (-1) porque JavaScript months son 0-based
       * - Maneja strings con o sin milisegundos
       * - Ignora información de zona horaria, trata como hora local
       */
    private parseLocalDateTime(dateTimeStr: string): Date {
      if(!dateTimeStr) {
        return;
      }
      const [datePart, timePartRaw] = dateTimeStr.split('T');
      if (!datePart || !timePartRaw) {
return null;
}

      const [year, month, day] = datePart.split('-').map(Number);

      const timePart = timePartRaw.replace('Z', '').split('.')[0]; // elimina "Z" y milisegundos
      const [hour, minute, second] = timePart.split(':').map(Number);

      // Parse as UTC so the browser does not shift the day based on its local timezone.
      return new Date(Date.UTC(year, month - 1, day, hour, minute, second));
    }


/**
 * Extrae la hora y minutos de un objeto Date en formato HH:mm:00
 *
 * Este método utility formatea la parte de tiempo de un objeto Date
 * a string en formato de 24 horas con segundos establecidos a '00'.
 *
 * @param dateTime - String representando una fecha/hora
 * @returns - Hora formateada como "HH:mm:00"
 *
 * @format
 * - Horas: 2 dígitos con leading zeros
 * - Minutos: 2 dígitos con leading zeros
 * - Segundos: siempre "00"
 *
 * @example
 * // Retorna: "15:30:00"
 * this._extractHourMinute('2023-12-25T15:30:45Z');
 *
 * @uses
 * - getHours(): Obtiene horas (0-23)
 * - getMinutes(): Obtiene minutos (0-59)
 * - padStart(2, '0'): Asegura 2 dígitos
 */
  private _extractHourMinute(dateTime: string): string {
    const date = new Date(dateTime);
    // Use UTC accessors because parseLocalDateTime() builds the Date with
    // Date.UTC(...). Reading getHours()/getMinutes() instead would convert
    // to the browser's local time and shift the displayed hour by the
    // timezone offset (e.g., a stored 08:00 UTC reads as 05:00 in
    // Argentina UTC-3, or 06:00 in Bolivia UTC-4 with DST variations).
    const hours = date.getUTCHours().toString().padStart(2, '0');
    const minutes = date.getUTCMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`;
  }

  resetForms(): void {
  // Resetear el formArray
  this.flightsInternalForm.reset();
}

minDateValidDeparture(index: number): Date {
  // Primer vuelo interno depende del vuelo general
  if (index === 0 && this.firstFly?.arrivalIn) {
    return new Date(this.firstFly.arrivalIn);
  }
  // Vuelos internos subsiguientes dependen del vuelo interno anterior
  else if (index > 0 && this.flightsInternal[index - 1]?.arrivalOut) {
    return new Date(this.flightsInternal[index - 1].arrivalOut);
  }
  // Fallback
  else {
    return new Date();
  }
}

minDateValidArrival(index: number): Date {
  // La fecha mínima de llegada es la fecha de salida del mismo vuelo interno
  const currentFlight = this.flightsInternal[index];
  return currentFlight?.departureOut ? new Date(currentFlight.departureOut) : new Date();
}

  // ========== WHEEL TIME PICKER ==========

  /**
   * Toggle the wheel time picker dropdown
   * @param index - flight index in the form array
   * @param field - field name: 'departureHourOut', 'arrivalHourOut', 'departureHourIn', 'arrivalHourIn'
   * @param event - click event
   */
  toggleTimePicker(index: number, field: string, event: Event): void {
    event.stopPropagation();
    const pickerKey = { index, field };
    const isSamePicker = this.activeTimePicker?.index === index && this.activeTimePicker?.field === field;
    this.activeTimePicker = isSamePicker ? null : pickerKey;
  }

  // Tracks previous valid time values per (index, field) so blur can revert.
  private _previousTimeValues: Record<string, string | null> = {};

  /**
   * Format-as-you-type handler for the manual time inputs.
   * Does NOT write to the form control here — it just sanitises the typed
   * string and visually inserts a colon after 2 digits.
   * Mirrors flight-modal.component.ts pattern.
   */
  _onManualTimeInput(event: Event, index: number, controlName: 'departureHourOut' | 'arrivalHourOut'): void {
    const input = event.target as HTMLInputElement;
    const raw = input.value;

    const digits = raw.replace(/\D/g, '').slice(0, 4);

    let formatted = digits;
    if (digits.length >= 3) {
      formatted = `${digits.slice(0, 2)}:${digits.slice(2)}`;
    } else if (digits.length === 2 && raw.includes(':')) {
      formatted = `${digits}:`;
    }

    if (input.value !== formatted) {
      const cursorPos = input.selectionStart || 0;
      input.value = formatted;
      const newPos = Math.min(cursorPos + (formatted.length - raw.length), formatted.length);
      input.setSelectionRange(newPos, newPos);
    }
  }

  /**
   * Blur handler. Validates and writes the final value to the per-flight form control.
   * Mirrors flight-modal.component.ts pattern, adapted to the FormArray index.
   */
  _onTimeInputBlur(
    index: number,
    controlName: 'departureHourOut' | 'arrivalHourOut',
    event: FocusEvent
  ): void {
    const input = event.target as HTMLInputElement;
    const dateField = controlName === 'departureHourOut' ? 'departureDateOut' : 'arrivalDateOut';
    const formGroup = this.flightsInternalForm.at(index) as FormGroup;
    const dateValue = formGroup.get(dateField)?.value;
    const fc = formGroup.get(controlName);

    const digits = input.value.replace(/\D/g, '');
    const cacheKey = `${index}_${controlName}`;
    if (digits.length === 0) {
      fc?.setValue(dateValue ? this.currentTime : null);
      input.value = dateValue ? this.currentTime : '';
      return;
    }

    const padded = digits.padEnd(4, '0').slice(0, 4);
    const hours = parseInt(padded.slice(0, 2), 10);
    const minutes = parseInt(padded.slice(2, 4), 10);

    if (hours < 0 || hours > 23 || minutes < 0 || minutes > 59) {
      const prev = this._previousTimeValues[cacheKey];
      const fallback = prev || (dateValue ? this.currentTime : null);
      fc?.setValue(fallback);
      input.value = fallback || '';
      return;
    }

    const formatted = `${padded.slice(0, 2)}:${padded.slice(2, 4)}`;
    fc?.setValue(formatted);
    input.value = formatted;
    this._previousTimeValues[cacheKey] = formatted;
  }

  /**
   * Close the wheel time picker dropdown
   */
  closeTimePicker(): void {
    this.activeTimePicker = null;
  }

  /**
   * Handle clicks outside the time picker to close it
   */
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (this.activeTimePicker) {
      const target = event.target as HTMLElement;
      // Check if click was inside any wheel-picker-wrapper
      const pickerWrapper = target.closest('.wheel-picker-wrapper');
      if (!pickerWrapper) {
        this.activeTimePicker = null;
      }
    }
  }

}
